<template>
    <b-modal
        id="common-info-modal"
        size="md"
        title="Подписка на месяц в подарок!"
        v-model="open"
        modal-class="unit_modal"
        hide-footer
        top
        @show="onShow"
    >
      <div class="content_info_block">
        <p>За каждого приведённого реферального пользователя,<br/> дарим Вам +1 месяц подписки в подарок! Реферальная ссылка находится в разделе <small class="link_btn" @click="linkClick">Настройки / Пользователи</small>. Обязательно сообщите нам имя приглашённого друга :)</p>
      </div>
    </b-modal>
</template>

<script>
export default {
  name: "CommonInfoModal",
  computed: {},
  components: {},
  data() {
    return {
      open: false
    }
  },
  methods: {
    onShow() {
    },
    linkClick() {
      this.$root.$emit('bv::hide::modal', 'common-info-modal');
      this.$router.push('/settings/users')
    },
    onClose() {

    },
  },
  mounted() {
    this.$store.subscribe(({type, payload}) => {
      if (type === 'openCommonInfoModal') this.open = true;
    })
  },
}
</script>


<style>
#common-info-modal .modal-title {
  font-size: 16px;
  margin: 0;
}

#common-info-modal .close_btn > i:before {
  font-size: 14px;
}

#common-info-modal .close_btn {
  padding: 4px;
}

#common-info-modal .modal-header {
  align-items: flex-start
}

#common-info-modal .content_info_block > p {font-size: 14px;}

@media (max-width: 992px) {
  #common-info-modal .modal-body {
    padding: 16px !important;
  }
}
</style>
